import { bulkStaticDefaults } from '@/config/static/catalog/bulk';
import type {
  BulkUserImportDraft,
  BulkUserImportSuccess,
  BulkUserImportFormStep,
} from '@/types/bulkUserImport';
import type { GuidedFlowDefinition } from './types';

export const bulkUserImportFlow: GuidedFlowDefinition<
  BulkUserImportDraft,
  BulkUserImportFormStep,
  BulkUserImportSuccess
> = {
  id: 'bulk-user-import',
  formTitle: bulkStaticDefaults.flowTitle,
  systemLabelPrefix: 'System',
  formSurface: 'bulk-review',
  hideStepper: true,
  exclusiveSavingScreen: false,
  steps: [{ id: 'review', label: 'Review' }],
  schemas: {
    review: {
      id: 'review',
      layout: 'stack',
      fields: [],
      nextLabel: 'Approve',
    },
  },
  approvalRows: [
    { key: 'Users to add', value: (draft) => String(draft.rows.length) },
    { key: 'Source file', value: (draft) => draft.csvFileName ?? 'Uploaded in review' },
  ],
  success: {
    bannerText: (result) =>
      result.addedCount === 1
        ? '1 person added.'
        : `${result.addedCount} people added.`,
    noteText: '',
  },
};
